import { useEffect } from 'react';

// Hook to load legacy scripts dynamically
export const useScripts = (scripts = []) => {
  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    };

    const loadScripts = async () => {
      try {
        for (const script of scripts) {
          await loadScript(script);
        }
      } catch (error) {
        console.error('Error loading scripts:', error);
      }
    };

    loadScripts();

    // Cleanup function
    return () => {
      scripts.forEach(script => {
        const scriptElement = document.querySelector(`script[src="${script}"]`);
        if (scriptElement) {
          scriptElement.remove();
        }
      });
    };
  }, [scripts]);
};

// Hook to load common scripts for all pages
export const useCommonScripts = () => {
  const commonScripts = [
    '/assets/js/common_scripts.js',
    '/assets/js/common_functions.js',
  ];

  useScripts(commonScripts);
};

// Hook to load page-specific scripts
export const usePageScripts = (pageType) => {
  const pageScripts = {
    home: ['/assets/js/slider.js'],
    gallery: [
      '/assets/js/gallery/isotope.js',
    ],
    lounge: [
      '/assets/js/datepicker_inline.js',
      '/assets/js/datepicker_search.js',
      '/assets/js/slider.js',
    ],
    dining: ['/assets/js/slider.js'],
    events: ['/assets/js/slider.js'],
    offers: ['/assets/js/slider.js'],
    about: ['/assets/js/slider.js'],
    contact: ['/assets/js/slider.js'],
  };

  const scripts = pageScripts[pageType] || [];
  useScripts(scripts);
};
